<template>
  <v-container class="coupon-container" style="padding:0 10px">
    <!-- <v-row>hello</v-row> -->
    <!-- 쿠폰 헤더 -->
    <v-row class="page-header mb-5">
      <div style="display:flex;align-items:center">
        <img :src="headerLogo" alt=""/>
        <span style="font-weight:bold;margin-left:4px;font-size:16px">쿠폰 정보</span>
      </div>
    </v-row>
    <!-- 쿠폰이미지 -->
    <v-row class="coupon-image mb-5">
      <div class="coupon-image-frame">
        <img :src="form.couponImg ? form.couponImg : basicImg" alt="쿠폰이미지"/>
      </div>   
    </v-row>
    <v-row style="justify-content: center;height: 60px;" class="mb-5">
      <div>
        <div class="coupon-title">{{ form.couponName?form.couponName:$t("coupon.msg.not_exists_coupon") }}</div>
      </div>
    </v-row>
    <v-row class="mb-5">
      <!-- 쿠폰내용 -->
      <div class="page-content" style="margin-bottom: 10px;">
        <div class="coupon-info">{{form.useplceName?testDate:''}}</div>
        <div class="coupon-info">{{useplcText}}</div>
        <div class="coupon-info">{{descriptionText}}</div>
      </div>
    </v-row>
    <!-- 하단 -->
    <v-row class="page-footer">
      <p class="coupon-code" style="margin-bottom:5px; font-size: 16px;">{{testText}}</p>
      <div v-if="btnYn && branchSeqSet" class="mt-2" style="width:250px">
        <rx-combo-box
        class="raceComboBox"
        v-model="form.branchSeq"
        comboType="select"
        codes="raceLocation"
        :excludes="excludeParks"
        label="입장파크"
        outlined
        dense
        hide-details
        ></rx-combo-box>
      </div>
      <div v-if="barcodeSet" class="barcode-timeArea">바코드 유효시간 : <div class="barcode-timer">{{bcTimeText}}</div></div>
      <div v-if="barcodeSet" class="barcode-area">
        <canvas ref="barcode"></canvas>
      </div>
      <div v-if="passSet" style="display: flex;flex-wrap: wrap;justify-content: center;">
        <input type="password" class="cpnPass" inputmode="numeric" v-model="form.couponManagaNo" placeholder=" 쿠폰 비밀번호" notnull colname="쿠폰비밀번호">
      </div>
      <div v-if="passSet" style="font-size:12px;font-weight: 700;">{{this.$t("coupon.msg.info_input_coupon_pass")}}</div>
      <!-- <v-select
        v-model="form.branchSeq"
        :items="selectItem"
      ></v-select> -->
      <div v-if="btnYn" class="coupon-btn" @click="useProcess">
        <div class="btn-text">{{btnText}}</div>
      </div>
      <div v-if="messageSet" style="margin-top:8px;white-space:pre-line;">
        <div>{{messageText}}</div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { $creBarCode,$couponCodeExchange, $useCoupon, $oferCouponDetail, $getCouponDetail } from "@/redcrm/api/coupon.js";
import JsBarcode from "jsbarcode";
export default {
  computed: {
    excludeParks(){
      const usable = (this.couponMaster && this.couponMaster.usePark) || [];
      if (!usable.length) return [];
      return this.$store.state.app.commCodes
      .filter((c)=>c.upCodeVal === "raceLocation")
      .map((c)=> c.codeVal)
      .filter((code)=>!usable.includes(code));
    },
    bcTimeText(){
      return `${this.bcTimeMin}분 ${this.bcTimeSec}초`;
    },
    testDate(){
      var today = this.$moment().format("YYYY-MM-DD");
      if(this.testSet){
        return "* 사용기간 : "+today + " ~ " + today
      }else{
        return "* 사용기간 : " + this.formatDate(this.form.couponStartDate) + " ~ " + this.formatDate(this.form.couponEndDate)
      }
    },
    useplcText(){
      if(this.form.useplcList && this.form.useplcList.length > 0){
        return "* 사용처 : " + this.form.useplcList.join(', ');
      }else{
        return ""
      }
    },
    descriptionText(){
      if(this.form.description){
        return "* " + this.form.description;
      }else{
        return ""
      }
    },
    testText(){
      if(this.testSet){
        return "모의발송으로 발송된 테스트 쿠폰입니다";
      }else{
        if(this.form.couponCode){
          return "쿠폰번호 : "+ this.form.couponCode
        }else{
          return '';
        }
      }
    },
    messageText(){
      switch(this.form.couponStatus){
        //사용한
        case "USED" :
          if(this.form.benefitType == "POINT"){
            return this.$t("coupon.msg.point_coupon_use_complted", [this.$moment(this.form.couponUsedAt).format('YYYY-MM-DD HH:mm')]);
          }else{
            return this.$t("coupon.msg.coupon_use_complted", [this.$moment(this.form.couponUsedAt).format('YYYY-MM-DD HH:mm')]);
          }
        //회수한
        case "EXPIRED_WITHDRAW" :
          return this.$t("coupon.msg.reclaimed_coupon");
        //만료된  
        case "EXPIRED_VALID" :
          return this.$t("coupon.msg.expired_coupon");
        //만료한
        default:
         return this.$t("coupon.msg.not_exists_coupon");
      }
    }
  },
  data() {
    return {
      isReject: false,
      headerLogo: require(`@/redworks/assets/coupon/cupon_header.png`),
      basicImg: require(`@/redworks/assets/coupon/basic_img.png`),
      boarderTop: require(`@/redworks/assets/coupon/border-top.png`),
      form : {
        couponManagaNo:"",
      },
      encodeForm:{},
      couponMaster:null,
      barcodeInfo:{},
      btnText: "사 용 처 리",
      btnYn: false,
      barcodeSet: false,
      passSet:false,
      messageSet: false,
      branchSeqSet: false,
      bcTimerId : null,
      bcTime : 0,
      bcTimeMin : 0,
      bcTimeSec : 0,
      testSet:false
    };
  },
  methods: {
    formatDate(date){
      if(date != null){
        const year = date.substring(0,4);
        const month = date.substring(4,6);
        const day = date.substring(6,8);
        return year + "년" + month +"월"+ day +"일"
      }
    },
    startBcTimer(seconds){
      //초기화
      this.bcTime = seconds;
      this.barcodeSet = true;
      this.btnYn = false;
      this.branchSeqSet = false;
      this.clearBcTimer();

      //타이머 시작
      this.bcTimerTick();
      this.bcTimerId = setInterval(this.bcTimerTick,1000);
    },
    bcTimerTick(){
      this.bcTimeMin = Math.floor(this.bcTime/60);
      this.bcTimeSec = this.bcTime % 60;

      this.bcTime--;
      //만료
      if(this.bcTime < 0){
        this.$rxSnackbar("warning",this.$t("coupon.msg.barcode_expired"));
        this.onBcTimerExpired();
      }
    },
    /* 바코드 유효시간 만료시 */
    onBcTimerExpired(){
      this.barcodeSet = false;
      this.btnYn = true;
      this.branchSeqSet = false;
      this.btnText = "재 발 급";
      this.clearBcTimer();
    },
    clearBcTimer(){
      if(this.bcTimerId){
        clearInterval(this.bcTimerId);
        this.bcTimerId = null;
      }
    },
    /* 바코드 생성 */
    async creBarCode() {
      try {
        //캠페인 발송의 경우,
        if(this.form.issueSrcCode !='EVENT' && this.encodeForm.branchSeq === ''){
          this.encodeForm.branchSeq = this.form.branchSeq;
        }
        const { data } = await $creBarCode(this.encodeForm);
        var result = data.result;
        if(result.freeAdmEvtYn == 'N'){
          //바코드 생성 확인
          if(result.isSuccess){
            this.barcodeInfo = data.result;
            await this.startBcTimer(600);
            JsBarcode(this.$refs.barcode, this.barcodeInfo.bcdNo, {
              width: 2,
              format: "CODE128",
              height: 70,
              margin: 20,
              textMargin: 15,
              font: "Roboto, sans-serif",
              fontSize: 14,
              lineColor: "#000000",
              background: "#ffffff",
              displayValue: true
            } );
          }else{
            this.$rxSnackbar("warning", result.errMsg); //오류 메시지 출력
          }
        }else{
          this.$rxSnackbar("warning", this.$t("coupon.msg.in_process_free_event")); //오류 메시지 출력
        }
      } catch (error) {
        this.$rxSnackbar("error", this.$t("coupon.msg.barcode_cre_error")); //오류 메시지 출력
      }
    },
    /* 쿠폰번호 암/복호화 */
    async exchangeCode(baseForm, flag) {
      try {

      let param = baseForm;
      param.flag = flag;

      const { data } = await $couponCodeExchange(param);
      this.encodeForm = data.result;
      }catch(e){
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error")); //오류 메시지 출력
      }
    },
    /* 쿠폰 사용 처리 */
    async useCoupon(){
      try{
        const { data } = await $useCoupon(this.form);
        this.form = data.result;
        this.$rxSnackbar("success", this.$t("coupon.msg.coupon_use_complt",  [this.$moment(this.form.couponUsedAt).format('YYYY-MM-DD HH:mm')])); 
      }catch(e){
        this.$rxSnackbar("error", e.response.data.messageDetail);
      }
    },
    async useProcess(){
      try{
        if(this.form.benefitType=='ENTER'|| this.form.benefitType=='SEAT'){
          if(this.form.couponStatus == 'ISSUE'|| this.form.couponStatus == 'CANCEL'){

            if(!this.form.branchSeq){
              this.$rxSnackbar("warning", this.$t("coupon.msg.branch_set")); //오류 메시지 출력
              return;
            }
             await this.exchangeCode(this.form, "e") //암호화
             this.creBarCode(); //바코드 생성
          }else{
            //사용 불가 쿠폰
            this.$rxSnackbar("error", this.$t("coupon.msg.used_coupon"));
          }

        }else if(this.form.isUsedPassword){
          if(this.form.couponManagaNo!=null && this.form.couponManagaNo.length > 0){
             if (
              await this.$rxConfirm(
                "info",
                this.$t("coupon.lbl.use_coupon"),
                this.$t("coupon.msg.coupon_use")
              )
            ){
              this.useCoupon();
            }
          }else{
            this.$rxSnackbar("error", this.$t("coupon.msg.input_coupon_pass"));
          }
        }else{
          this.useCoupon();
        }
      }catch(e){
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error")); //오류 메시지 출력
      }
    },
    /* 사용 쿠폰 조회 */
    async oferCouponDetail(){
      try{
        const { data } = await $oferCouponDetail(this.couponCode);
        const result = data.result
        this.couponMaster = result;
        //할인/증정 & 비밀번호 사용시
        if((result.benefitType == "DISCOUNT" || result.benefitType == "OTHER_PRODUCT") && result.isUsedPassword){
          this.form = data.result;
          this.btnYn = true;
          this.passSet = true;
          this.btnText="사 용 처 리"
          //입장료 & 바코드 사용 시
        }else if(result.benefitType == "ENTER" || result.isUsedBarcode){
          this.form = data.result;
          this.btnYn = true;
          this.btnText="쿠 폰 발 급"
          if(this.form.issueSrcCode !='EVENT' && this.form.branchSeq === null){
            this.branchSeqSet= true;
          }
          //포인트 
        }else if(result.benefitType == "POINT"){
          this.form = data.result;
          this.btnText="사 용 처 리"
          this.btnYn = true;
        //그외 존재X
        }
      }catch(e){
         if (e.response && e.response.data.messageCode == "404-5") {
            this.$rxSnackbar(
              "error",
              this.$t("coupon.msg.not_exists_coupon")
            );
         }else{
           this.$rxSnackbar("error", this.$t("common.msg.unexpected_error")); //오류 메시지 출력
         }
      }
    },
    async getCouponDetail(couponMstId){
      try{
      const { data } = await $getCouponDetail(couponMstId);
      const result = data.result
      this.couponMaster = result;
        //할인/증정 & 비밀번호 사용시
        if((result.benefitType == "DISCOUNT" || result.benefitType == "OTHER_PRODUCT") && result.isUsedPassword){
          this.form = data.result;
          this.btnYn = true;
          this.passSet = true;
          this.btnText="사 용 처 리"
          //입장료 & 바코드 사용 시
        }else if(result.benefitType == "ENTER" || result.isUsedBarcode){
          this.couponMaster = result;
          this.form = data.result;
          this.btnYn = true;
          this.btnText="쿠 폰 발 급"
          if(this.form.issueSrcCode !='EVENT' && this.form.branchSeq === null){
            this.branchSeqSet= true;
          }
          //포인트 
        }else if(result.benefitType == "POINT"){
          this.form = data.result;
          this.btnText="사 용 처 리"
          this.btnYn = true;
        //그외 존재X
        }
      }catch(e){
         if (e.response && e.response.data.messageCode == "404-5") {
            this.$rxSnackbar(
              "error",
              this.$t("coupon.msg.not_exists_coupon")
            );
         }else{
           this.$rxSnackbar("error", this.$t("common.msg.unexpected_error")); //오류 메시지 출력
         }
      }
    }
  },
  async mounted() {
    var key = this.$route.query.key || this.$route.query.k || 'undefined';
    this.couponCode = key;

    if(key.includes("TESTCOUPONCODE")){
      this.testSet = true;
      await this.getCouponDetail(key.replace("TESTCOUPONCODE",""));
    } else{
      await this.oferCouponDetail();
    }
  },
  watch:{
    "form.couponStatus"(newVal){
      if(!(newVal == 'ISSUE' || newVal == 'CANCEL')){
        this.messageSet = true;
        this.passSet = false;
        this.btnYn = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  margin:0;
}
.page-header {
  height: 50px;
  border-bottom:1px solid #dedede;
  align-items:center
}
.coupon-image {
  justify-content: center;
  padding: 10px;
}
.coupon-image-frame {
  border: 1px solid #dedede;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coupon-image-frame img{
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.coupon-title{
  position: relative;
  text-align:center;
  padding:7px 10px 8px 10px;
  font-size:17px;
  font-weight:bold;
  color:#222222;
}
.coupon-title::after{
    //border-bottom: 3px solid #fd5f02;
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 180px;
    height: 3px;
    background: #1976d2;
    transform: translateX(-50%);
  }
.coupon-info {
  font-size: 13px;
  color: gray;
}
.page-footer-border{
  height:4px;
  padding:0;
  background-repeat: repeat-x;
}
.page-footer {
  display: flex;
  flex-wrap: nowrap;
  background: #f7f7f7;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  background-image: url('~@/redworks/assets/coupon/border-top.png');
  background-position: top left;
  background-repeat: repeat-x;
}
.coupon-btn {
  cursor: pointer;
  border: 1px solid #1976d2;
  border-radius: 15px;
  background: #1976d2;
  padding: 8px 30px;
  margin-top:20px;
}
.btn-text {
  color:#f7f7f7;
}
.barcode-area{
  background-color: white;
}
.barcode-timeArea{
  font-weight: bold;
  margin-bottom: 15px;
}
.barcode-timer{
  display: inline-block;
  font-weight: bold;
  color: #b8271f;
}
.cpnPass{
  border-style: dashed;
  padding: 8px 10px;
  margin:8px 0;
  font-size:15px;
}
.coupon-container {
  font-family: "SUIT", "LINESeedJP", "Noto Sans KR", "Noto Sans JP", sans-serif, "Apple SD 산돌고딕 Neo";
  font-weight: 400;
}


//다크모드 대응
</style>
